function emptySelect2(element, emptyOption= "Seleccione una opción", emptyVal = true) {
    // 1. Verificar si Select2 ya está activo en este elemento
    if (element.hasClass("select2-hidden-accessible")) {
        // TODO Alternativa: Destruirlo para reinicializarlo limpiamente después
        // element.select2('destroy');

        // Limpiar la selección interna
        element.val(null);
    }
    // Limpiar lista
    element.empty();
    // Agregar la opción por defecto
    element.append('<option value="">'+emptyOption+'</option>');
    // Forzar a Select2 a actualizarse sin disparar bucles infinitos si es posible
    //  Nota: 'change.select2' es específico del plugin y a veces evita bucles de eventos nativos
    element.trigger('change');
}

function checkAndFetchModel(edit = false) {
    const brand_id = $('#parent_brand_id').val();
    const bci_id = $('#parent_bci_id').val();
    let model_id = null
    $('#models').val([]) // $('#models').val(null)
    emptySelect2($('#battery_model_id'), 'Seleccione un Modelo', false)
    // $('#battery_model_id').empty();
    // $('#battery_model_id').val(null).trigger('change')
    if (brand_id && bci_id) {
        if(edit === true) {
            model_id = $('#edit_model_id').val()
        }
        fetchModel(brand_id, bci_id, model_id);
    }
}
function setModel() {
    let models = JSON.parse($('#models').val())
    if(models) {
        let data = models.filter(m => ''+m.id === ''+$('#battery_model_id').val())[0]
        if(!undefinedOrNull(data)) {
            data['name'] && invalidString(name) && $('#parent_name').val(data['name'])
            data['c_a'] && $('#parent_ca').val(data['c_a']);
            data['c_c_a'] && $('#parent_cca').val(data['c_c_a']);
            data['reserve_capacity_min'] && $('#parent_reserve_capacity_min').val(data['reserve_capacity_min']);
            data['list_price_iva'] && $('#parent_list_price_iva').val(data['list_price_iva']);
            data['list_price'] && $('#parent_list_price').val(data['list_price']);
            data['warranty'] && $('#parent_warranty').val(data['warranty']);
            data['warranty_fleet'] && $('#parent_warranty_fleet').val(data['warranty_fleet']);
            data['weight'] && $('#parent_weight').val(data['weight']);
            data['plates'] && $('#parent_plates').val(data['plates']);
            data['volts'] && $('#parent_volts').val(data['volts']);
            data['length'] && $('#parent_length').val(data['length']);
            data['width'] && $('#parent_width').val(data['width']);
            data['high'] && $('#parent_high').val(data['high']);
        }
    }
}
function fetchModel(brand_id, bci_id, model_id = null) {
    const url = '/get/battery/models'
    $.get(url, {brand_id: brand_id, bci_id: bci_id}, function(data) {
        if (data) {
            if(data.models) {
                $('#models').val(JSON.stringify(data.models))
            }
            $('#battery_model_id').select2({
                data: data.selectable,
                tokenSeparators: [',', ' '],
                theme: "classic",
                width: 'resolve'
            });
            if(!undefinedOrNull(model_id)) {
                const model_id = $('#edit_model_id').val();
                $('#battery_model_id').val(model_id);
                $('#battery_model_id').trigger('change');
            }
            setModel()
        } else {
            cwarn('empty model data.')
        }
    });
}

function fetchGroup() {
    const bci_id = $('#parent_bci_id').val();
    const url = '/get/bci/group/'+bci_id;
    // $.get(url, {name: name, type: type}, function(data) {
    $.get(url, {}, function(data) {
        if (data) {
            data['batteries_groups_id'] && $('#battery_group_id').val(data['batteries_groups_id']).trigger('change');
        } else {
            cwarn('empty bci group.')
        }
    });
}

$(document).on('change', '#parent_list_price', setPriceIva)
$(document).off('change', '#parent_list_price', setPriceIva)
function setPriceIva() {
    let value = $('#parent_list_price').val()
    if(!undefinedOrNull(value) && value !== ''){
        $('#parent_list_price_iva').val(parseInt(value)*1.16)
    }
}

function destroyBatteriesBatch() {
    if(document.getElementById('batteries_form')) {
        document.removeEventListener('turbolinks:before-cache', destroyBatteriesBatch)
        document.removeEventListener('turbolinks:load', setupBatteriesBatch)
        $('#parent_bci_id').off('select2:select', fetchGroup);
        $('#parent_group_id, #parent_brand_id, #parent_bci_id').off('select2:select', checkAndFetchModel);
        $('#parent_name, #parent_type').off('change', checkAndFetchModel);
        $('#battery_model_id').off('select2:select', setModel);
        $(document).off('change', '#parent_list_price', setPriceIva)
    }
}

function setupBatteriesBatch() {
    if(document.getElementById('batteries_form')) {
        $('#parent_bci_id').on('select2:select', fetchGroup);
        $('#parent_group_id, #parent_brand_id, #parent_bci_id').on('select2:select', checkAndFetchModel);
        $('#battery_model_id').on('select2:select', setModel);
        $('#parent_name, #parent_type').on('change', checkAndFetchModel);
        $(document).on('change', '#parent_list_price', setPriceIva)
        checkAndFetchModel(true)
    }
}

$(document).on('turbolinks:load', setupBatteriesBatch)
window.addEventListener('beforeunload', (event) => {
    destroyBatteriesBatch();
});

window.checkAndFetchModel = checkAndFetchModel;
window.fetchModel = fetchModel;
